import { mensagemDeErro } from '@common/errors/mensagemDeErro';
import { useAuth } from '@features/auth';
import { CampanhaDoMomento } from '@features/campanhas';
import { useCampanhaAtiva } from '@features/formulario';
import { useIdentidade } from '@features/identidade';
import { Alert, Badge, PageHeader, Skeleton } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

function SeuCadastro() {
  const { t } = useTranslation('identidade');
  const { t: tErros } = useTranslation('erros');
  const { data, isLoading, error } = useIdentidade();

  return (
    // Uma linha discreta sob a saudação; o título fica só para leitor de tela.
    <section className="flex flex-col gap-1 text-sm text-foreground-muted">
      <h2 className="sr-only">{t('titulo')}</h2>
      {isLoading && <Skeleton className="h-5 w-64" />}
      {error && <Alert variant="danger">{tErros(mensagemDeErro(error))}</Alert>}
      {data?.situacao === 'vinculado' && (
        <p>
          {t('vinculado', { nome: data.profissional?.nomeExibicao ?? '' })}
          {data.origem === 'ultimo_conhecido' && ` ${t('ultimoConhecido')}`}
        </p>
      )}
      {/* Mesma mensagem para sem_correspondencia e duplicado: a tela não revela qual (R6). */}
      {data && data.situacao !== 'vinculado' && (
        <Alert variant="warning" title={t('falha.titulo')}>
          {t('falha.descricao')}
        </Alert>
      )}
    </section>
  );
}

export function InicioPage() {
  const { t } = useTranslation('inicio');
  const { user } = useAuth();
  // R27: quem não é administrador vai direto ao formulário quando há campanha ativa.
  const ehAdmin = !!user?.roles.includes('administrador');
  const ativa = useCampanhaAtiva(!!user && !ehAdmin);
  // Erro na identidade: sem "Responder" no cartão (spec 29 R25).
  const vinculado = useIdentidade().data?.situacao === 'vinculado';
  if (user && !ehAdmin) {
    if (ativa.isLoading) return <Skeleton className="h-10 w-64" />;
    if (ativa.data) return <Navigate to={`/responder/${ativa.data.id}`} replace />;
  }

  return (
    <div className="flex flex-col gap-6">
      {/* Spec 29 R20 a R26: o cartão da campanha do momento vem antes da saudação. */}
      {ehAdmin && <CampanhaDoMomento vinculado={vinculado} />}
      <div className="flex flex-col gap-1">
        {/* Saudação e perfis numa linha; o cadastro logo embaixo, sem seção própria. */}
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
          <PageHeader title={t('saudacao', { nome: user?.name ?? '' })} />
          <div className="flex flex-wrap gap-2">
            {user?.roles.map((role) => (
              <Badge key={role} tone={role === 'administrador' ? 'brand' : 'neutral'}>
                {t(`perfis.${role}`)}
              </Badge>
            ))}
          </div>
        </div>
        <SeuCadastro />
      </div>
    </div>
  );
}
